import React from 'react';
import PhaserGame from './PhaserGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <PhaserGame />
    </div>
  );
}

export default App;
